import React, { useRef, useEffect, useContext, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import OperationsMenu from "../components/OperationMenu";
import moment from "moment";
import back_icon from "../img/readingSpace_icons/return_icon.svg";

import AuthContext from "../context/authContext";
import io from "socket.io-client";
import {
  Divider,
  Layout,
  Typography,
  Image,
  Button,
  Switch,
  Row,
  Col,
  Input,
  Modal,
  Card,
  Menu,
  Space,
  Flex,
} from "antd";
import ReaderMode from "../components/ReaderMode";
import { CheckOutlined } from "@ant-design/icons";

import { connectWebSocket, sendWord } from "../components/SocketSender";

import AudioRecorder from "../components/AudioRecorder";

import { ArrowLeftOutlined } from "@ant-design/icons";

// import IllusMakerAppContainer from "../Modals/IllusMakerAppContainer";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { MultiBackend, TouchBackend } from "react-dnd-touch-backend";
import Messages from "../components/Messages";
import WordDetective from "../Modals/WordDetective";

import record from "../img/record_selected_64.png";
import authoring from "../img/authoring_selected_64.png";
import read_aloud from "../img/read_aloud_selected_64.png";
import word_clarification from "../img/word_clarification_selected_64.png";
import word_cloud from "../img/word_wall_selected_64.png";
import effects from "../img/effects_selected_64.png";

import streenTheme from "../theme";



const verbose = true; // set to true to enable debug logging
const vlog = (...args) => verbose && console.log(...args);


// Ensure the connection is established once
let isConnected = false;

const operationIcons = {
  record: record,
  authoring: authoring,
  read_aloud: read_aloud,
  word_clarification: word_clarification,
  word_cloud: word_cloud,
  effects: effects,
};

const Read = ({ presentationMode, setPresentationMode }) => {
  const { Content } = Layout;
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const {
    showMessageError,
    showMessageWarning,
    showMessageInfo,
    showMessageSuccess,
  } = Messages();

  // Safely extract storyId and groupId
  const selectedStory = location.state || {};
  const activity = location.state?.activity;
  const [storyId, setStoryId] = useState(selectedStory?.storyId || "");
  const [groupId, setGroupId] = useState(selectedStory?.groupId || null);
  const [taskCategory, setTaskCategory] = useState(
    selectedStory?.taskCategory || null
  );
  
  // Set selectedOperation from location state or localStorage
  // This ensures that when users navigate back from Studio/Gestalten, their operation is preserved
  useEffect(() => {
    // First check if there's a selectedOperation in location state
    // if (location.state?.selectedOperation) {
    //   setSelectedOperation(location.state.selectedOperation);
    // } 
    // If not, check localStorage for a saved studio operation
    if (localStorage.getItem('selectedStudioOperation')){
      const savedStudioOperation = localStorage.getItem('selectedStudioOperation');
      if (savedStudioOperation) {
        setSelectedOperation(savedStudioOperation);
      } else {
        // Otherwise start with no operation selected to give users a fresh choice
        setSelectedOperation(null);
      }
    }
  }, []); // Run only once on mount
  
  useEffect(() => {
    if (!storyId) {
      vlog("No storyId provided! Redirecting...");
      navigate("/"); // Redirect to home if storyId is missing
    }
  }, [storyId, groupId, navigate]);

  // Handle scroll to make FAB button sticky
  const [isFabSticky, setIsFabSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Check scroll position and update sticky state
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // Make button sticky when scrolled down about 126px (138px initial - 12px sticky position)
      setIsFabSticky(scrollTop > 126);
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  vlog("Story ID:", storyId);
  vlog("Group ID:", groupId); // Will be `null` if not provided

  //  const [storyId, setStoryId] = useState(selectedStory?.id || "");
  const [storyTitle, setStoryTitle] = useState(selectedStory?.title || "");

  const [storyImg, setStoryImg] = useState(selectedStory?.img || "");

  const [storyDescription, setStoryDescription] = useState(
    selectedStory?.desc || ""
  );
  const [storyCategory, setStoryCategory] = useState(selectedStory?.cat || "");
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [selectedSentences, setSelectedSentences] = useState([]);

  const [selectedOperation, setSelectedOperation] = useState(null);
  const [navToGestaltenPage, setNavToGestaltenPage] = useState(false);

  const [storyHighlights, setStoryHighlights] = useState([]);



  const { Text, Title } = Typography;
  const [isEditing, setIsEditing] = useState(false);
  const [originalSentences, setOriginalSentences] = useState([]);
  const [sentences, setSentences] = useState([]);

  const [isLexi, setIsLexi] = useState(false);

  const [recordedAudio, setRecordedAudio] = useState(null);

  const operationBackgrounds = {
    record: "#90e3ff",

    read_aloud: "#e6f7ff",

    word_clarification: "#fff0bc",
    word_cloud: "#fcffb8",

    authoring: "#b6ffde",
    effects: "#c2ffbd",
  };
  const headerBackground = operationBackgrounds[selectedOperation] || "#f7faff";

  const handleRecordingComplete = (audioBlob) => {
    // Handle the recorded audio blob, e.g., upload to server or attach to the story
    setRecordedAudio(audioBlob);
    console.log("Recording complete. Audio Blob:", audioBlob);
  };

  const handleTextChange = (sentenceId, wordIndex, newValue) => {
    const updatedSentences = selectedSentences.map((sentence) => {
      if (sentence.id === sentenceId) {
        const updatedWords = [...sentence.words];
        updatedWords[wordIndex] = newValue;
        return { ...sentence, words: updatedWords };
      }
      return sentence;
    });
    setSelectedSentences(updatedSentences);
  };
  const handleSelectOperation = (operation) => {
    setSelectedOperation(operation);
  };

  
  const handleSocketRequestToDMC = async (sentenceIndex, wordSpanIndex) => {
    // const socket = io('http://localhost:3001');
    // const request = 'Sample request from Client UI';
    // socket.emit('request-from-clientUI', request);
  };
  const handleStoryEdit = async (storyId, sentenceId, wordSpanId) => {
    // setIsEditing(!isEditing);
  };
  const handleEnrichment = async (storyId, sentenceId, wordSpanId) => {
    try {
      console.log("userid", currentUser);
      console.log("Fetching enrichments with params:", {
        storyid: storyId,
        sentenceid: sentenceId,
        userid: currentUser.id,
        wordspanid: wordSpanId,
        groupId: Number(groupId),
      });
      const getEnrichment = await axios.get(`/api/enrichments/`, {
        params: {
          storyid: storyId,
          sentenceid: sentenceId,
          userid: currentUser.id,
          wordspanid: wordSpanId,
          groupId: Number(groupId),
        },
      });
      console.log("get enrichments 1");
      console.log("getEnrichment", getEnrichment.data);
      const getEnrichmentIllus = await axios.get(
        `/api/enrichments/${getEnrichment.data[0].id}`
      );

      console.log("getEnrichmentIllus", getEnrichmentIllus.data);
      console.log("get asset data");

      const getStoryAsset = await axios
        .get(`/api/assets/${storyId}`)
        .catch((error) => {
          console.error("Error loading JSON:", error);
        });
      console.log("DynamicJson:::", getStoryAsset);
      const base64Data = getEnrichmentIllus.data.illusdata_str;

      const jsonData = JSON.parse(base64Data); // Parse JSON string to get JSON object
      console.log(
        "storyId:%s, \nsentence.id:%s, \nwordSpanId:%s",
        storyId,
        sentenceId,
        wordSpanId
      );
      // const enrichment_key = "" + storyId + "-" + sentenceId + "-" + wordSpanId;
      const enrichment_key = {
        wordspanid: wordSpanId,
        illusdata_str: jsonData,
        dynamic_json: getStoryAsset.data,
      };

      console.log(enrichment_key);
      console.log(
        "process.env.REACT_APP_CLIENT_URL: ",
        process.env.REACT_APP_CLIENT_URL
      );

      const socket = io(process.env.REACT_APP_CLIENT_URL, {
        path: "/socket.io",
        transports: ["websocket", "polling"],
        secure: true, // browser enforces this automatically
        extraHeaders: {
          "Content-Type": "application/json",
        },
      });
      const request = enrichment_key;
      // socket.emit("get-session-info", sessionValue);
      socket.emit("request-from-clientUI", request);

      // Update the state with the enrichments
      // setStoryEnrichments([...storyEnrichments, response.data]);
    } catch (error) {
      console.error("Error fetching enrichments", error);
    }
  };

  const handleHighlight = async (
    sentenceIndex,
    wordSpanIndex,
    highlightColor
  ) => {
    // Implement Word Highlight functionality
    // Change cursor style to pencil icon

    try {
      const response = await axios.post(`/api/highlights/`, {
        storyhid: storyId,
        sentenceid: sentenceIndex,
        userid: currentUser.id,
        wordspanid: wordSpanIndex,
        color: highlightColor,
      });

      // Update the state with the new highlight
      setStoryHighlights([...storyHighlights, response.data]);
    } catch (error) {
      console.error("Error creating highlight:", error);
    }
  };

  const handleWordClarification = async (word, wordSpanId) => {
    setIsLexi(!isLexi);
    // try {
    //   const response = await axios.post(`https://llm.ais-lab.eu/simple-chat`, {
    //     prompt: "what is the meaning of the "+ word +" in German?"},
    //     {
    //       headers: {
    //         Authorization: `Basic ${btoa(`groupIP2025:Ip@ais2025`)}`,
    //       },
    //   });

    //   console.log("response from LLM:", response.data);

    // } catch (error) {
    //   console.error("Error handleWordClarification:", error);
    // }
  };
  const cleanWord = (word) => {
    return word.replace(/[^a-zA-Z0-9äöüÄÖÜß]/g, "");
  };

  const handleWordCloud = async (word, isSelected) => {
    try {
      console.log("Initializing WebSocket connection...");

      if (!isConnected) {
        const socket = await connectWebSocket();
        isConnected = true;
        // socket.emit("get-session-info", sessionValue);
      }

      word = cleanWord(word);

      console.log("word cloud");
      if (isSelected) {
        sendWord("| " + word + " "); // Add the word to the word cloud
      } else {
        sendWord("rm| " + word + " "); // Remove the word from the word cloud
      }
    } catch (error) {
      console.error("Error using word cloud:", error);
    }
  };

  const handleAuthoring = async (sentenceIndex, wordSpanIndex) => {
    // Implement Trigger functionality

    try {
      const response = await axios.post(`/api/enrichments/`, {
        storyid: storyId,
        sentenceid: sentenceIndex,
        userid: currentUser.id,
        wordspanid: wordSpanIndex,
        type: "default",
        specification: "default",
      });

      console.log("enrichment created:", response.data);

      // Update the state with the new highlight
      setStoryHighlights([...storyHighlights, response.data]);

      // Navigate to illusmaker with selected word or sentence
      const selectedWord =
        typeof sentenceIndex === "string" ? sentenceIndex.split("_")[1] : "";
      const selectedSentence = selectedSentences.find(
        (sentence) => sentence.id === sentenceIndex
      );

      // Navigate to the illusmaker page with the selected word and sentence
      navigate("/illusmaker", {
        state: {
          selectedWord,
          selectedSentenceText: selectedSentence.text,
          selectedStory,
        },
      });
    } catch (error) {
      console.error("Error creating enrichment:", error);
    }
  };

  const handleDictionaryLookup = () => {
    // Implement Dictionary Lookup functionality
  };

  useEffect(() => {
    /* // Update cursor acording to function
    document.body.className = '';

    if (selectedOperation === 'highlight') {
      document.body.classList.add('cursor-highlight');
    } else if (selectedOperation === 'tts') {
      document.body.classList.add('cursor-tts');
    } else if (selectedOperation === 'dictionary') {
      document.body.classList.add('cursor-dictionary');
    }*/
  }, [selectedOperation]);

  /* useEffect(() => {

    console.log("READ WRITE storyId", storyId);

    let isMounted = true;
    const fetchData = async () => {
      try {
        const sentenceResponse = await axios.get(
          `/sentences/?storyid=${storyId}`
        );
        const characterResponse = await axios.get(
          `/characters/?storycharid=${storyId}`
        );

        // Fetch highlights associated with the current story
        const highlightResponse = await axios.get(`/api/highlights/?storyhid=${storyId}`);
        //console.log("highlightResponse::", highlightResponse.data);
        const underlineResponse = await axios
        .get(`/enrichments/`, {
          params: {
            storyid: storyId,
            userid: currentUser.id,  // Needed to check private enrichments
            groupId:  Number(groupId) || 0,  // Needed to check group enrichments
          },
        })       
        .catch((error) => {
          console.error("Error fetching enrichments:", error);
        });
      
        console.log("get enrichments 3", underlineResponse);
        // .then((response) => setStoryEnrichments(response.data));
        // .catch((error) => console.error("Could not fetch sentence enrichments:", error));
        if (isMounted) {
          setSelectedSentences(sentenceResponse.data);
          setSelectedCharacters(characterResponse.data);
          setStoryHighlights(highlightResponse.data);
          // storyEnrichments are now managed locally in ReaderMode
          

           // Apply highlights to words (moved from the previous location)
          highlightResponse.data.forEach((highlight) => {
            const { sentenceid, wordspanid, color } = highlight;
            const [sentenceIndex, wordIndex] = wordspanid.split('_').slice(1).map(Number);

            const wordElement = document.getElementById(`word_${sentenceIndex}_${wordIndex}`);
            
            // console.log('Word Element    :', wordElement);

            if (wordElement) {
              wordElement.style.backgroundColor = color;
            }
          });
          // underlineResponse.data.forEach((underline) => {
          //   // console.log('Underline::',underline);
          //   const {sentenceid, wordspanid } = underline;
          //   console.log('Underline::',wordspanid);
          //   const wordElement = document.getElementById(wordspanid)
          //   if(wordElement){
          //     wordElement.style.textDecoration = "underline";
          //   }

          // });
        }
      } catch (err) {
        console.log(err);
      }
    };

  // Fetch immediately, then every 10 seconds
  fetchData();
  const interval = setInterval(fetchData, 10000);

  // todo replace in the future by websockets
  // todo e.g.: socket.on("updateData", (data) => {  if (data.updateEnrichments === true) { fetchData(); } });

    return () => {
      isMounted = false;
    };
  }, [storyId]);



  const disableScroll = (e) => {
    e.preventDefault();
  };

*/
  // useEffect(async () => {
  //   const socket = await connectWebSocket();
  //   console.log("Session Disconnection Effect triggered");
  //   socket.on("session-disconnected", msg => {
  //     showMessageInfo(msg);
  //     setSessionValue(null);
  //   });
  // },[]);
  useEffect(() => {
    console.log("READ WRITE storyId", storyId);

    let isMounted = true;

    

    const fetchStoryData = async () => {
      try {
        const sentenceResponse = await axios.get(
          `/api/sentences/?storyid=${storyId}`
        );
        const characterResponse = await axios.get(
          `/api/characters/?storycharid=${storyId}`
        );
        const highlightResponse = await axios.get(
          `/api/highlights/?storyhid=${storyId}`
        );

        if (isMounted) {
          
          // Sort sentences based on the 'ord' field
          const sortedSentences = [...sentenceResponse.data].sort(
            (a, b) => Number(a.ord) - Number(b.ord)
          );

          setSelectedSentences(sortedSentences);
          setSelectedCharacters(characterResponse.data);
          setStoryHighlights(highlightResponse.data);

          // Apply highlights to words
          highlightResponse.data.forEach((highlight) => {
            const { wordspanid, color } = highlight;
            const [sentenceIndex, wordIndex] = wordspanid
              .split("_")
              .slice(1)
              .map(Number);
            const wordElement = document.getElementById(
              `word_${sentenceIndex}_${wordIndex}`
            );

            if (wordElement) {
              wordElement.style.backgroundColor = color;
            }
          });
        }
      } catch (err) {
        console.error("Error fetching story data:", err);
      }
    };

    // Initial fetch
    fetchStoryData();
    // fetchEnrichments();

    // Fetch enrichments every 10 seconds - TODO: Replace with WebSocket updates in the future
    // const interval = setInterval(fetchEnrichments, 10000);

    return () => {
      isMounted = false;
      // clearInterval(interval);
    };
  }, [storyId, currentUser.id, groupId]);

  useEffect(() => {
    // window.addEventListener('wheel', disableScroll, { passive: false });
    // window.addEventListener('keydown', disableScroll, { passive: false });

    // return () => {
    //   window.removeEventListener('wheel', disableScroll);
    //   window.removeEventListener('keydown', disableScroll);
    // };
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setPresentationMode(false);
        document.body.style.overflow = "auto";
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", handleFullscreenChange);

    // Cleanup event listeners on component unmount
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "MSFullscreenChange",
        handleFullscreenChange
      );
    };
  }, []);
  const togglePresentationMode = (checked) => {
    setPresentationMode(checked);
    try {
      if (checked) {
        document.body.style.overflow = "hidden";

        // Enter fullscreen
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen();
        } else if (document.documentElement.msRequestFullscreen) {
          document.documentElement.msRequestFullscreen();
        }
      } else {
        // Exit fullscreen
        document.body.style.overflow = "auto";
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        setPresentationMode(false);
      }
    } catch (error) {
      console.error("Error exiting fullscreen mode:", error);
      setPresentationMode(false);
    }
  };
  

  // useEffect(() => {
  //   console.log("taskCategory", taskCategory);
  //   if (taskCategory === "record" || taskCategory === "feedback") {
  //     setSelectedOperation("record");
  //   } else if (taskCategory === "enrichments") {
  //     setSelectedOperation("authoring");
  //   } else if (taskCategory === "analyze") {
  //     setSelectedOperation("word_cloud");
  //   } else if (taskCategory === "hexiLexi") {
  //     setSelectedOperation("word_clarification");
  //   } else if (taskCategory === "vorlesen") {
  //     setSelectedOperation("effects");
  //   } else {
  //     setSelectedOperation(null);
  //   }

  // }, [taskCategory]); // Run this effect whenever taskCategory changes

  return (
    <Content>
      <Flex align="start" wrap="wrap" gap="large" className="reading-space">      
        {/* READING SPACE HEADER */}
        <Flex align="start" wrap="wrap" gap="large" 
          className="reading-space header-row"
        >
          
          {/* LEFT SIDE – Icon + Title + Activity */}
          <Flex vertical gap="small" className="reading-space header-left">
            <Flex align="center" gap="middle" className="reading-space header-nav">
              <Button
                icon={
                  <img
                    src={back_icon}
                    alt=""
                    style={{
                      width: 29,
                      height: 29,
                    }}
                  />
                }
                onClick={() =>
                  navigate("/", {
                    state: { selectedActivity: activity },
                  })
                }
                className="reading-space return-btn"
              />
              <Title level={5} style={{ paddingBottom: 8 }} className="reading-space return-btn-text">
                {groupId ? "Aufgabenübersicht": "Geschichtenübersicht"}
              </Title>
            </Flex>

            <Flex className={`reading-space operation-menu-fab-btn ${isFabSticky ? "sticky" : ""}`}>
              <OperationsMenu
                setNavToGestaltenPage={setNavToGestaltenPage}
                selectedOperation={selectedOperation}
                onSelectOperation={handleSelectOperation}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
              />
            </Flex>
          </Flex>
          {/* MIDDLE – TITLE AND STORY IMAGE */}
          <Flex
            vertical
            align="center"
            justify="center"
            className="reading-space header-middle"
          >
            <Title
              level={2}
              className="reading-space header-title"
            >
              {storyTitle}
            </Title>

            <Flex
              align="center"
              justify="center"
              className="reading-space header-image-wrapper"
            >
              <Image
                preview={false}
                src={storyImg}
                className="reading-space header-image"
              />
            </Flex>
          </Flex>
          
          
          
        </Flex>
        {/* READING SPACE PANEL */}
        <Flex className="reading-space reader-panel" style={{ flex: "1 1 auto", minWidth: 300 }}>
            <ReaderMode
              storyTitle={storyTitle}
              storyId={storyId}
              setSelectedSentences={setSelectedSentences}
              selectedSentences={selectedSentences}
              setSelectedCharacters={setSelectedCharacters}
              selectedCharacters={selectedCharacters}
              storyHighlights={storyHighlights}
              // storyEnrichments and setStoryEnrichments are now managed locally in ReaderMode
              selectedOperation={selectedOperation}
              handleSelectOperation={handleSelectOperation}
              handleHighlight={handleHighlight}
              handleWordClarification={handleWordClarification}
              handleEnrichment={handleEnrichment}
              handleAuthoring={handleAuthoring}
              handleStoryEdit={handleStoryEdit}
              handleWordCloud={handleWordCloud}
              onAuthoringClick={(sentence, wordSpanId, character) => {
                navigate("/Studio", {
                  state: {
                    selectedSentences,
                    selectedCharacters,
                    sentence,
                    wordSpanId,
                    character,
                    storyId,
                    groupId,
                    storyTitle,
                    selectedStory,
                    selectedOperation,
                  },
                });
              }}
              navToGestaltenPage={navToGestaltenPage}
              handleAudioRecording={handleRecordingComplete}
              isEditing={isEditing}
              isLexi={isLexi}
              setIsLexi={setIsLexi}
              presentationMode={presentationMode}
              setPresentationMode={setPresentationMode}
              currentGroupId={groupId}
              currentVisibility={"group"}
            />
          </Flex>
      </Flex>
      {/* </div> */}
    </Content>
  );
};

export default Read;
